import { Audio } from "react-loader-spinner";
import { twMerge } from "tailwind-merge";
import { Exercise } from ".";
import ProgressionChart from "../HistoryWrapper";

interface ExerciseItemProps {
  exercise: Exercise;
  style: React.CSSProperties;
  index: number;
  isLoading: boolean; // Agora estamos passando isso
  key: string;
}

const ExerciseItem: React.FC<ExerciseItemProps> = ({
  exercise,
  style,
  index,
  isLoading,
  key,
}) => (
  <div
    key={key}
    style={style}
    className={twMerge(
      "flex flex-col p-4",
      index % 2 === 0 ? "rounded bg-zinc-100 dark:bg-zinc-800" : "",
    )}
  >
    {isLoading ? (
      <div className="flex h-[400px] w-full items-center justify-center">
        <Audio color="#777" height={40} width={40} />
      </div>
    ) : (
      <ProgressionChart
        data={exercise.exercise_data}
        exerciseName={exercise.exercise_name}
      />
    )}
  </div>
);

export default ExerciseItem;
